// extracted by mini-css-extract-plugin
export var root = "CallToAction-module--root--7QYSV";
export var box = "CallToAction-module--box--3Nood";
export var button = "CallToAction-module--button--1j0-C";
export var icon = "CallToAction-module--icon--17iV5";